import { isSentSouthpawJobStatus } from "@punchup/data/models/messaging";
import { Badge } from "../../shadcn/ui/badge";
import { cn } from "@punchup/utils/cn";

export type MessageStatus = "sent" | "sending" | "scheduled" | "failed";

const STATUS_CONFIG: Record<
  MessageStatus,
  { label: string; className: string }
> = {
  sent: {
    label: "Sent",
    className: "bg-green-600 hover:bg-green-600 text-white border-transparent",
  },
  sending: {
    label: "Sending…",
    className: "bg-sky-500 hover:bg-sky-500 text-white border-transparent",
  },
  scheduled: {
    label: "Scheduled",
    className: "bg-blue-600 hover:bg-blue-600 text-white border-transparent",
  },
  failed: {
    label: "Failed",
    className: "bg-red-600 hover:bg-red-600 text-white border-transparent",
  },
};

/**
 * Normalize a job status string into a display status.
 * "sending" -> "sending" (handed to the email dispatch service, still
 * draining), other sent statuses (see isSentSouthpawJobStatus) -> "sent",
 * "scheduled" -> "scheduled", anything else -> "failed"
 */
export function normalizeJobStatus(status: string): MessageStatus {
  const lower = status.toLowerCase();
  if (lower === "sending") return "sending";
  if (isSentSouthpawJobStatus(lower)) return "sent";
  if (lower === "scheduled") return "scheduled";
  return "failed";
}

/**
 * Colored status pill for message jobs.
 * Green for sent, sky for sending, blue for scheduled, red for failed.
 */
export function MessageStatusBadge({ status }: { status: string }) {
  const normalized = normalizeJobStatus(status);
  const config = STATUS_CONFIG[normalized];

  return (
    <Badge className={cn("text-xs font-semibold", config.className)}>
      {config.label}
    </Badge>
  );
}
